<template>
  <div>
    <div
      class="incoming-tender-list-row"
      :class="{
        'tender-list__parent-row': row.row.group_level,
        'incoming-tender-list-row_short': !showLabourMaterialTools,
        'incoming-tender-list-row_changed': row.changed_in_last_edit && showChangesFromCustomer,
      }"
    >
      <div class="tender-list-cell tender-list-cell_numbering">
        <span>{{ rowIndex + 1 }}</span>
      </div>
      <div class="tender-list-cell tender-list-cell_description">
        <ArrowIcon
          v-if="row.row.group_level"
          class="pointer"
          :class="{ 'turn-over': isTurnOverArrow }"
        />
        <div class="d-contents spacex-8">
          <div class="tender-list-cell_description__title-wrapper">
            <div class="tender-list-cell_description__title">
              {{ row.row.description_of_works }}
            </div>
            <div
              v-if="row.breakdown_rows && row.breakdown_rows.length"
              class="toggle-breakdown-btn unselectable"
              @click="toggleBreakdown"
            >
              {{ showBreakdown ? $t('Hide') : $t('Show') }}
              {{ $t('breakdown details') }}
            </div>
          </div>
          <Button
            v-if="!this.isNotInvitedIncomingTender"
            :id="`comment-${row.id}`"
            color="neutral"
            type="ghost"
            size="small"
            icon
            class="tender-list-cell_description__btn"
            @click.stop="$emit('open-comments')"
          >
            <MessageIcon class="icon-n-2" />
          </Button>
          <Button
            v-if="showCreateSubpositionButton"
            color="neutral"
            type="ghost"
            size="small"
            icon
            class="tender-list-cell_description__btn"
            @click="
              createBreakdownRow({
                rowId: row.id,
                total: +row.total ? row.total : null,
              })
            "
          >
            <TableIcon />
          </Button>
        </div>
      </div>
      <div class="tender-list-cell">
        <span v-if="!row.row.group_level && row.row.unit">
          {{ unitName(row.row.unit.name) }}
        </span>
      </div>
      <div class="tender-list-cell tender-list-cell_value">
        <span v-if="!row.row.group_level">{{ row.row.quantity }}</span>
      </div>
      <IncomingTenderListCell
        v-for="column in columnKeys"
        :key="column.title"
        :row="row"
        :field="column.title"
        :currency="incomingTenderInfo.currency"
        :hide-values="!!row.row.group_level"
        :content-editable="!row.row.group_level && !row.breakdown_rows.length && column.canBeEdited"
        :class="{ 'right-sticky-cell': column.isSticky }"
        :order-of-rows-ids="orderOfRowsIds"
        :order-of-fields-to-edit="ORDER_OF_FIELDS_TO_EDIT"
        @edit-cell-value="editCellValue"
      />
    </div>
    <IncomingTenderListBreakdown
      v-if="showBreakdown && row.breakdown_rows && row.breakdown_rows.length"
      :currency="incomingTenderInfo.currency"
      :breakdown-rows="row.breakdown_rows"
      :parent-row-index="rowIndex"
      :parent-row-id="row.id"
      :column-keys="columnKeys"
      :show-labour-material-tools="showLabourMaterialTools"
      :version-is-draft="versionIsDraft"
      :order-of-rows-ids="breakdownOrderRowsIds"
    />
  </div>
</template>

<script>
  import ArrowIcon from '@/assets/icons/chevron-down.svg';
  import TableIcon from '@/assets/icons/table.svg';
  import Button from '@/components/ui/Button';
  import IncomingTenderListCell from '@/containers/incoming-tender/incoming-tender-list/IncomingTenderListCell';
  import IncomingTenderListBreakdown from '@/containers/incoming-tender/incoming-tender-list/IncomingTenderListBreakdown';
  import { mapActions, mapState, mapGetters } from 'vuex';
  import MessageIcon from '@/assets/icons/message-border.svg';
  import unitName from '@/utils/mixins/get-unit-name';

  export default {
    name: 'IncomingTenderListRow',
    components: {
      IncomingTenderListBreakdown,
      IncomingTenderListCell,
      ArrowIcon,
      TableIcon,
      Button,
      MessageIcon,
    },
    props: {
      rowIndex: {
        type: Number,
        required: true,
      },
      row: {
        type: Object,
        required: true,
      },
      columnKeys: {
        type: Array,
        required: true,
      },
      showLabourMaterialTools: {
        type: Boolean,
        required: true,
      },
      isTurnOverArrow: {
        type: Boolean,
        default: false,
      },
      selectedVersion: {
        type: Object,
        required: true,
      },
      orderOfRowsIds: {
        type: Array,
        default: () => [],
      },
    },
    mixins: [unitName],
    data() {
      return {
        showBreakdown: true,
        ORDER_OF_FIELDS_TO_EDIT: ['labour', 'materials', 'tools'],
      };
    },
    computed: {
      ...mapState('incomingTender', ['incomingTenderInfo', 'showChangesFromCustomer']),
      ...mapGetters({
        isNotInvitedIncomingTender: 'incomingTender/isNotInvitedIncomingTender',
      }),
      versionIsDraft() {
        return this.selectedVersion.status === 'draft';
      },
      showCreateSubpositionButton() {
        return (
          !this.row.breakdown_rows?.length &&
          !this.row.row.group_level &&
          !this.isNotInvitedIncomingTender &&
          this.versionIsDraft
        );
      },
      breakdownOrderRowsIds() {
        return this.row?.breakdown_rows?.map((row) => row.id) || [];
      },
    },
    methods: {
      ...mapActions('incomingTender', ['createBreakdownRow', 'editIncomingTenderCellValue']),
      editCellValue(updatedCell) {
        this.editIncomingTenderCellValue(updatedCell);
      },
      toggleBreakdown() {
        this.showBreakdown = !this.showBreakdown;
      },
    },
  };
</script>
